module.exports = __webpack_public_path__ + "media/Schön wie du bist.299e2c4d.mp3";